{
    "Profile_CommonComponents_Quotes.messagesHeader": "FR: Important Messages",
    "Profile_CommonComponents_Quotes.taxesIncluded": "FR: {estimatedAnnualGross} per year (taxes included)",
    "Profile_CommonComponents_Quotes.quoteNo": "FR: Quote No: {referenceNumber}",
    "Profile_CommonComponents_Quotes.acceptQuote": "FR: Accept Quote",
    "Profile_CommonComponents_Quotes.acceptingQuoteTitle": "FR: Accepting a quote",
    "Profile_CommonComponents_Quotes.acceptingQuoteConfirmation": "FR: Your documents will be sent to your broker to be processed. Are you sure?",
    "Profile_CommonComponents_Quotes.acceptingQuoteNotification": "FR: You will be notified by email when they are ready to sign, as soon as possible.",
    "Profile_CommonComponents_Quotes.yes": "FR: Yes",
    "Profile_CommonComponents_Quotes.cancel": "FR: Cancel",
    "Profile_CommonComponents_Quotes.userCurrentChoice": "FR: Applicant Choice"
}
